/**=========================================================
 * Module: messages.js
 * Messages Controller
 =========================================================*/

App.controller('MessagesController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'toaster',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, toaster) {
    "use strict";


    $scope.pop = function(type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
    };

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

        if($scope.project.id && $rootScope.user.id){
            $scope.reader = $rootScope.user.id;
            $scope.initialized = true;

            var recipients = [];
            var recipientNames = [];
            if($rootScope.user.group.type=='CLIENT'){
                recipients[0] = $scope.project.supplier;
                recipientNames[0] = $scope.project.supplierName;
                recipients[1] = 'AQRATE';
                recipientNames[1] = 'AQRATE';
            } else if($rootScope.user.group.type=='SUPPLIER'){
                recipients[0] = $scope.project.group;
                recipientNames[0] = $scope.project.groupName;
                recipients[1] = 'AQRATE';
                recipientNames[1] = 'AQRATE';
            } else {
                recipients[0] = $scope.project.group;
                recipientNames[0] = $scope.project.groupName;
                recipients[1] = $scope.project.supplier;
                recipientNames[1] = $scope.project.supplierName;
            }

            var isClientAbsent = !$scope.type && $scope.project.group==='leo'
            var isSupplierAbsent = $scope.type=='client'

            if(isClientAbsent){
                if($rootScope.user.group.type=='SUPPLIER'){
                    recipients[0] = 'AQRATE';
                    recipientNames[0] = 'AQRATE';
                    recipients[1] = null;
                    recipientNames[1] = null;
                } else if($rootScope.user.admin){
                    recipients[1] = null;
                    recipientNames[1] = null;
                    recipients[0] = $scope.project.supplier;
                    recipientNames[0] = $scope.project.supplierName;
                }    
            }

            let startSanitizeNode = function () {
                const iframe = document.querySelector('.nw-editor__res');

                if (iframe && iframe.contentDocument) {
                    const style = iframe.contentDocument.createElement('style');
                    style.innerHTML = `
                    h1 {
                        font-size: 1.5em;
                    }
                    `;
                    iframe.contentDocument.head.appendChild(style);
                    
                    const iframeBody = iframe.contentDocument.body;

                    iframeBody.addEventListener('paste', function () {
                    setTimeout(() => {
                        const cleaned = sanitizeHtmlUserInput(iframeBody.innerHTML);

                        iframeBody.innerHTML = cleaned;

                        const ngScope = angular.element(iframe).scope();
                        ngScope.$apply(() => {
                            ngScope.userHtml = cleaned;
                        });
                    }, 100);
                    });
                } else {
                    $timeout(function () {
                        startSanitizeNode();
                    }, 1000);
                }
            };

            function sanitizeHtmlUserInput(inputHtml) {
                const allowedTags = ['h1', 'p', 'b', 'u', 'i', 'br', 'div', 'ol', 'ul', 'li'];
                const wrapper = document.createElement('div');
                wrapper.innerHTML = inputHtml;

                function clean(node) {
                    let child = node.firstChild;

                    while (child) {
                        const next = child.nextSibling;
                        if (child.nodeType === Node.ELEMENT_NODE) {
                            const tag = child.tagName.toLowerCase();
                            if (tag === 'img') {
                                $scope.pop('info', $filter('translate')('labels.UPLOADINSTEADOFPASTE'));
                                child.remove();
                            } else if (!allowedTags.includes(tag)) {
                                clean(child);
                                while (child.firstChild) {
                                    node.insertBefore(child.firstChild, child);
                                }
                                child.remove();
                            } else {
                                for (let i = child.attributes.length - 1; i >= 0; i--) {
                                    child.removeAttribute(child.attributes[i].name);
                                }
                                clean(child);
                            }
                        }
                        child = next;
                    }
                }

                clean(wrapper);
                return wrapper.innerHTML;
            }


            var initMessageForm = function(afterNewMessage){
                startSanitizeNode();
                $scope.messageForm = {
                    cls: 'form-compact',
                    type: 'message',
                    model: {
                        body: afterNewMessage || !$scope.messageForm ? '' : $scope.messageForm.model.body,
                        recipient: afterNewMessage || !$scope.messageForm ? '' : $scope.messageForm.model.recipient,
                        tempId: afterNewMessage || !$scope.messageForm ? $rootScope.generateUUID(true, '_TEMP_') : $scope.messageForm.model.tempId
                    },
                    fields: [
                        {
                            available: true,
                            type: 'editor',
                            name: 'body',
                            hideAdvancedEditor: true,
                            label: $scope.type && $scope.type.indexOf('review-')>=0 ? 'labels.MESSAGEWITHREVIEW' : 'labels.MESSAGEWITH',
                            labelParams: { client: isClientAbsent ? '' : $scope.project.groupName+' ('+$scope.project.ownerName+')', supplier: isSupplierAbsent ? '' : $scope.project.supplierName },
                            labelColumn: 12,
                            inputColumn: 12,
                            rows: 5,
                            tooltip: function(){ return ($rootScope.user.groupType=='CLIENT' || $rootScope.user.groupType=='SUPPLIER') && !$scope.type ? {
                                name: 'PROCESSPROJECTMESSAGE' + ($rootScope.user.groupType=='SUPPLIER' ? 'SUPPLIER' : ''),
                                wait: 2,
                                position: 'top',
                                attachTo: '.app-field-body textarea',
                                arrowSize: 'long'
                            } : null }()

                        },{
                            available: true,
                            type: 'toggle',
                            label: 'labels.ATTACHFILES',
                            icon: 'aqi-attachment',
                            name: 'toggleattach',
                            toggle: 'attach',
                            noLabel: true,
                            labelColumn: 0,
                            inputColumn: 12
                        },{
                            available: afterNewMessage || !$scope.messageForm ? false : ($rootScope.files['message'+$scope.messageForm.model.tempId+'attach'] && $rootScope.files['message'+$scope.messageForm.model.tempId+'attach'].length>0),
                            type: 'file',
                            name: 'attach',
                            limit: -1,
                            noLabel: true,
                            inputColumn: 12,
                            labelColumn: 0,
                            canUpload: true,
                            bucket: $rootScope.bucketName($scope.project.group),
                            filesSelectable: $rootScope.user.admin,
                            selectionActions: [
                                { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                            ] 
                        },{
                            available: !$scope.type && !!recipients[0] && !!recipients[1],
                            type: 'radio',
                            name: 'recipient',
                            options: [
                                { value: '', label: $filter('translate')('labels.MESSAGERECIPIENTSBOTH', {'_0':recipientNames[0], '_1':recipientNames[1]}).replace('&amp;','&') },
                                { value: recipients[0], label: $filter('translate')('labels.MESSAGERECIPIENTSONE', {'_0':recipientNames[0], '_1':recipientNames[1]}).replace('&amp;','&') },
                                { value: recipients[1], label: !!$scope.notifyClient ? $filter('translate')('labels.MESSAGERECIPIENTSONE', {'_0':recipientNames[1], '_1':recipientNames[0]}).replace('&amp;','&') : $filter('translate')('labels.MESSAGERECIPIENTSNOCLIENT', {'_0':recipientNames[1], '_1':recipientNames[0]}).replace('&amp;','&') }
                            ],
                            tooltip: function(){ return ($rootScope.user.groupType=='CLIENT' || $rootScope.user.groupType=='SUPPLIER') && !$scope.type ? {
                                name: 'PROCESSPROJECTRECIPIENT',
                                wait: 4,
                                position: 'right',
                                attachTo: '.app-field-recipient input:first',
                                arrowSize: 'long'
                            } : null }()
                        },{
                            available: true,
                            type:'submit',
                            name:'empty',
                            labelColumn: 10,
                            inputColumn: 2
                        }
                    ],
                    submit: function(){
                        $scope.messageForm.status = 'submitting';
                            var m = this.model;
                            m.project = $scope.project.id;
                            m.type = $scope.type ? $scope.type : '';
                            D.save('message', m).then(
                                function(response){
                                    $scope.messageForm.model.body = '';
                                    var el = angular.element('#Files_attach_'+$scope.messageForm.model.tempId);
                                    if(el && el.scope()) el.scope().fileUploadList = [];
                                    $scope.messageForm.model.tempId = $rootScope.generateUUID(true, '_TEMP_');
                                    $scope.messageForm.fields[2].available = false;
                                    $scope.messageForm.status = '';
                                    $scope.messageForm.model.recipient = null;
                                    $scope.load(true);
                                }
                                
                            ).catch(function(response){
                                    $scope.messageForm.status = 'error';
                                    if(response.data && response.data.exc=='EntityValidationException'){
                                        //if(response.data.msg.indexOf('body')===0)
                                            $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), $filter('translate')('labels.BODYEMPTY'));

                                    }
                                })
                    }
                };
            }

            $scope.lastT = 0;
            $scope.listenToChanges = function(){
                FIREBASE.listen('Message', $scope.project.id + ($scope.type ? $scope.type : ''), function(value){
                    if(value && FIREBASE.isAfter(value.timestamp,$scope.lastT) && $scope.lastT>0){
                        $timeout(function(){
                            $scope.load(false);
                        }, 5000)
                    }
                }, null, { interval: 60000 });
            }
            $scope.listenToChanges();

            $scope.load = function(afterNewMessage){
                
                $scope.lastT = 0;
                D.query('message','project='+$scope.project.id + ($scope.type ? $scope.type:''), { cache: false }).then(
                    function(response){
                        $scope.messages = response;
                        for(var i=0; i<$scope.messages.length; i++){
                            $scope.messages[i].recent = new Date().getTime() - $scope.messages[i].T < 30000;
                            
                            let messageHtml = $scope.messages[i].body.replace(/\{\{\s*([^\|]+?)\s*\|translate[:]*(\{[\w\s\d\W\D\S]+?\})*\}\}/g, function(m, p1, p2){
                                try{
                                    p2 = JSON.parse(p2)
                                } catch(e){ 
                                    p2 = null
                                }
                                return $filter('translate')(p1, p2)
                            })

                            if($scope.messages[i].body!=messageHtml || $scope.messages[i].body.match(/<\/?[a-z][\s\S]*>/i)){
                                $scope.messages[i].body = ''
                                $scope.messages[i].html = messageHtml
                            }
                        }
                        $scope.lastT = $scope.messages[0] ? $scope.messages[0].T : 1;
                    }
                ).catch(console.error);

                $scope.notifyClient = true
                if(!$scope.type && $rootScope.user.group.type!='CLIENT'){
                    D.load('account', $scope.project.owner, { cache: false }).then(function(response){
                        if(response.opts.nomessagetoother){
                            $scope.notifyClient = false
                        }
                        initMessageForm(afterNewMessage)
                    }).catch(function(err){
                        initMessageForm(afterNewMessage)
                    })
                } else {
                    initMessageForm(afterNewMessage)
                }
                //$timeout($scope.load, 30000);
            };
            $scope.load(false);

        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;

                $scope.$watch('project.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });

                $scope.$watch('$root.user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();

    $scope.$on('$destroy', function iVeBeenDismissed() {
      // say goodbye to your controller here
      // release resources, cancel request...
      
      $scope.load = function() { };
    });

  }
  ]);
